import { routes } from "@src/appV2/redesign/utils/routes";
import { isDefined } from "@clipboard-health/util-ts";
import { matchPath } from "react-router-dom";

interface CanKeepAuthenticatedLayoutMountedParams {
  access: unknown;
  admin: boolean;
  hasRequiredProfileData: boolean;
  isWorkplace: boolean;
}

const AUTH_ONLY_ROUTE_PATTERNS = [
  routes.login,
  routes.legacyLoginVerify,
  routes.v2LoginWithEmailPassword,
  routes.v2ResetPassword,
  "/v2/email-login-link",
];

const AUTHENTICATED_SESSION_EFFECT_BYPASS_ROUTE_PATTERNS = [
  routes.v2LoginWithEmailPassword,
  routes.v2ResetPassword,
  "/v2/email-login-link",
  "/v2/sso-callback",
];

export function canKeepAuthenticatedLayoutMountedDuringSessionRefresh({
  access,
  admin,
  hasRequiredProfileData,
  isWorkplace,
}: CanKeepAuthenticatedLayoutMountedParams): boolean {
  return isWorkplace && !admin && hasRequiredProfileData && isDefined(access);
}

export function isAuthOnlyRoute(pathname: string): boolean {
  return AUTH_ONLY_ROUTE_PATTERNS.some((pattern) =>
    matchPath(pathname, { path: pattern, exact: true })
  );
}

export function shouldBypassAuthenticatedSessionEffects(pathname: string): boolean {
  return AUTHENTICATED_SESSION_EFFECT_BYPASS_ROUTE_PATTERNS.some((pattern) =>
    matchPath(pathname, { path: pattern, exact: true })
  );
}
